import styles from "./product-price.module.less";
import PropTypes from "prop-types";

const Price = (props) => {
  const {
    price,
    previousPrice,
    currencyDisplayName,
    className,
    priceClassName,
    previousPriceClassName,
    customPriceText,
    ignoreComponentTheme,
  } = props;

  const isPriceValid = price >= 0;

  return (
    <span
      className={[
        className,
        styles.priceWrapper,
        previousPrice > -1 ? styles.priceWrapper_discounted : "",
        ignoreComponentTheme ? "" : styles.activeComponentTheme,
      ].join(" ")}
    >
      {customPriceText ? (
        <span className={[styles.price, priceClassName].join(" ")}>{customPriceText}</span>
      ) : (
        <>
          {isPriceValid && previousPrice > -1 && (
            <span className={[styles.previousPrice, previousPriceClassName].join(" ")}>
              {previousPrice} {currencyDisplayName}
            </span>
          )}
          {isPriceValid && (
            <span className={[styles.price, priceClassName].join(" ")}>
              {price} {isPriceValid ? currencyDisplayName : undefined}
            </span>
          )}
        </>
      )}
    </span>
  );
};

Price.propTypes = {
  price: PropTypes.number,
  previousPrice: PropTypes.number,
  currencyDisplayName: PropTypes.string,
  className: PropTypes.string,
  priceClassName: PropTypes.string,
  customPriceText: PropTypes.string,
  ignoreComponentTheme: PropTypes.bool,
};

export default Price;
